<template>
  <div class="pageination">
    <!-- 当当前页是1的时候，禁用 -->
    <button
      :disabled="myCurrentPage === 1"
      :class="{ disabled: myCurrentPage === 1 }"
      @click="setCurrentPage(myCurrentPage - 1)"
    >
      <i class="el-icon-arrow-left"></i>
    </button>
    <button v-if="startEnd.start > 1" @click="setCurrentPage(1)">1</button>
    <button class="disabled" v-if="startEnd.start > 2">...</button>
    <button
      v-for="item in startEndArr"
      :key="item"
      :class="{ active: item === myCurrentPage }"
      @click="setCurrentPage(item)"
    >
      {{ item }}
    </button>
    <button class="disabled" v-if="startEnd.end < totalPage - 1">...</button>
    <button v-if="startEnd.end < totalPage" @click="setCurrentPage(totalPage)">
      {{ totalPage }}
    </button>
    <button
      :disabled="myCurrentPage === totalPage"
      :class="{ disabled: myCurrentPage === totalPage }"
      @click="setCurrentPage(myCurrentPage + 1)"
    >
      <i class="el-icon-arrow-right"></i>
    </button>
    <button class="disabled">共 {{ total }} 条</button>
  </div>
</template>

<script>
export default {
  name: "Pageination",
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },

    showPageNo: {
      type: Number,
      default: 3,
      validator: function (value) {
        return value % 2 === 1;
      },
    },
  },

  data() {
    return {
      myCurrentPage: this.currentPage,
    };
  },

  computed: {
    totalPage() {
      const { total, pageSize } = this;
      return Math.ceil(total / pageSize);
    },

    startEnd() {
      const { myCurrentPage, showPageNo, totalPage } = this;
      let start, end;
      start = myCurrentPage - Math.floor(showPageNo / 2);
      if (start < 1) {
        start = 1;
      }

      end = start + showPageNo - 1;

      if (end > totalPage) {
        // 修改end为totalPage
        end = totalPage;
        // reset start
        start = end - showPageNo + 1;
        if (start < 1) {
          start = 1;
        }
      }
      return { start, end };
    },

    startEndArr() {
      const arr = [];
      const { start, end } = this.startEnd;
      for (let page = start; page <= end; page++) {
        arr.push(page);
      }

      return arr;
    },
  },

  methods: {
    // 切换页码
    setCurrentPage(page) {
      // 如果页码没有改变，依然点击了，直接return
      if (page === this.myCurrentPage) return;

      this.myCurrentPage = page;
      // 分发自定义事件，告诉父组件
      this.$emit("currentChange", page);
    },
  },

  watch: {
    /**
     * 监视父组件传来的页码。同步更新页码
     */
    currentPage(value) {
      this.myCurrentPage = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.pageination {
  button {
    margin: 0 2px;
    background-color: transparent;
    color: #ffffff;
    outline: none;
    border-radius: 2px;
    vertical-align: top;
    display: inline-block;
    font-size: 16px;
    padding: 0 2px;
    height: 28px;
    line-height: 28px;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid #409eff;

    &.active {
      background-color: #409eff;
      color: #fff;
      cursor: not-allowed;
    }

    &.disabled {
      cursor: not-allowed;
      color: rgba(255, 255, 255, 0.5);
    }
  }
}
</style>